import { render, staticRenderFns } from "./KanbanCardModal.vue?vue&type=template&id=bf8d209e&scoped=true&"
import script from "./KanbanCardModal.vue?vue&type=script&lang=js&"
export * from "./KanbanCardModal.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCardModal.vue?vue&type=style&index=0&id=bf8d209e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8d209e",
  null
  
)

export default component.exports